import React, {useEffect, useRef, useState} from "react";
import {FormattedMessage} from "react-intl";
import closeIcon from "../../assets/img/icon_closed_grey.svg";
import analyticsLogEvent from "../../services/FirebaseService";
import {FIREBASE_SCREEN_NAMES, LOCALSTORAGE_ITEMS} from "../../util/Constants";
import * as StorageService from "../../services/StorageService";
import Spinner from "../../components/Spinner";
import {useLocation, useNavigate} from "react-router";
import 'react-phone-number-input/style.css';
import 'react-phone-input-2/lib/style.css'
import {getPhoneVerificationCodeHandler, updateUserProfileHandler} from "../../handlers/HandlerUserProfile";
import {useParams} from "react-router-dom";
import {getMinAndSecondsFromSeconds, toMinutes} from "../../util/common";


function PhoneUpdateEnterPin() {
    const navigateTo = useNavigate();
    const visible = "visible";
    const hidden = "hidden";
    let userInfo = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO)) : null;
    const inputRefs = useRef([]);
    const {phone} = useParams();
    const token = StorageService.getItem(LOCALSTORAGE_ITEMS.PHONE_TOKEN) ? StorageService.getItem(LOCALSTORAGE_ITEMS.PHONE_TOKEN) : null;
    const tokenTs = StorageService.getItem(LOCALSTORAGE_ITEMS.PHONE_TOKEN_TS) ? StorageService.getItem(LOCALSTORAGE_ITEMS.PHONE_TOKEN_TS) : null;

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    let countdown = query.get('countdown');


    const defaultCodeValue = Array(1).fill('');
    const [state, setState] = useState({
        loading: false,
        errorMsg: null,
        phone: userInfo?.phone ? userInfo?.phone : null,
        confirmationCodeDefaultValue: defaultCodeValue,
        verificationCodeScreenIsVisible: false,
        gender: userInfo?.gender,
        isSubmitBtnEnabled: true,
        updatedAccountPopupStyle: hidden,
        verificationCodePopupStyle: hidden,
        closeVerificationPopupStyle: hidden,
        verificationCodeInfoFromServer: null,
        resendTimer: null,
        blockedFor5Mins:countdown ? true: false
    });

    useEffect(() => {
      console.log(state.resendTimer);
    }, [state.resendTimer]);

    useEffect(() => {
        confirmPhoneNumber();
    }, [state.confirmationCodeDefaultValue]);



    useEffect(() => {

        let elapsedTime = new Date().getTime() - tokenTs;
        if (elapsedTime > 5 * 60 * 1000) {
            elapsedTime = 0;
        }else{
            elapsedTime = (5 * 60 * 1000) - elapsedTime;
        }

        const remainingTime = Math.floor(elapsedTime / 1000);
        if (remainingTime > 0) {
            setState(prevState => ({
                ...prevState,
                resendTimer: remainingTime
            }));
        }
    }, []);


    useEffect(() => {
        if (state.resendTimer === null) return;
        const interval = setInterval(() => {
            setState(prevState => {
                const newTime = prevState.resendTimer - 1;
                if (newTime <= 0) {
                    clearInterval(interval);
                    return { ...prevState, resendTimer: 0 };
                }
                return { ...prevState, resendTimer: newTime };
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [state.resendTimer]);


    useEffect(() => {
        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.PROFILE_UPDATE,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.PROFILE_UPDATE
        });
    }, []);

    useEffect(() => {
        inputRefs.current = inputRefs.current.slice(0, state.confirmationCodeDefaultValue.length);
    }, [state.confirmationCodeDefaultValue.length]);


    const closeProcess = () => {
        navigateTo(-2);
    }


    const handleCodeChangeAndVerification = (e, index) => {
        const newCode = [...state.confirmationCodeDefaultValue];
        newCode[index] = e.target.value;
        setState((prevState) => ({
            ...prevState,
            confirmationCodeDefaultValue: newCode,
        }));
    }


    const bodyForVerificationCodeRequest = {
        "email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
        "phone": phone,
        "locale": StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)
    }
    const resendCode = async () => {
        if (state.resendTimer > 0) return;

        await getPhoneVerificationCodeHandler(bodyForVerificationCodeRequest).then(response => {
            if (response.ok) {
                if (Object.keys(response.data).length === 0) {
                    setState(prevState => ({
                        ...prevState,
                        errorMsg: <FormattedMessage id="SmsShouldBeOnTheWay" defaultMessage="SmsShouldBeOnTheWay"/>,
                    }));
                } else {
                    setState(prevState => ({
                        ...prevState,
                        errorMsg: null,
                        verificationCodeScreenIsVisible: true,
                        verificationCodeInfoFromServer: response.data,
                        verificationCodePopupStyle: visible,
                    }));
                }
            } else {
                setState(prevState => ({
                    ...prevState,
                    errorMsg: <FormattedMessage id="VerificationIsTemporaryLocked"/>
                }));
            }

            setTimeout(() => {
                setState(prevState => ({
                    ...prevState,
                    verificationCodePopupStyle: hidden,
                }));
            }, 2000);
        });
    };


    const confirmPhoneNumber = async () => {
        if (!state.confirmationCodeDefaultValue || state.confirmationCodeDefaultValue.join("").length < 4) {
            return;
        }
        const body = {
            "email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "phone": phone,
            "code": state.confirmationCodeDefaultValue.join(""),
            "token": token
        }


        const response = await updateUserProfileHandler(body);
        if (response.ok) {
            userInfo = {
                ...userInfo,
                "phone": phone
            }
            StorageService.setItem(LOCALSTORAGE_ITEMS.USER_INFO, JSON.stringify(userInfo));
            setState({
                ...state,
                confirmationCodeDefaultValue: defaultCodeValue,
                updatedAccountPopupStyle: visible,
                loading: false,
                isSubmitBtnEnabled: false,
                errorMsg: null
            })

            setTimeout(function () {
                closeProcess();
            }, 2000);

        } else if (response.data.code === 403) {
            setState({
                ...state,
                isSubmitBtnEnabled: true,
                errorMsg: <FormattedMessage id="InvalidVerificationCode"/>,
                loading: false,
                confirmationCodeDefaultValue: defaultCodeValue,
            })
        } else {
            setState({
                ...state,
                isSubmitBtnEnabled: true,
                errorMsg: <FormattedMessage id="InvalidVerificationCode"/>,
                loading: false,
                confirmationCodeDefaultValue: defaultCodeValue,
            })
        }
    }


    const setCloseVerificationModalStyle = (style) => {
        setState({
            ...state,
            closeVerificationPopupStyle:style
        })
    }

    const onCloseBtn = () => {
        if  (state.resendTimer > 0 && !state.blockedFor5Mins) {
            setState({
                ...state,
                closeVerificationPopupStyle:visible
            })
        }else{
            closeProcess();
        }
    }


    return (
        <div className="page-content without-actionsbar">
            <div className={state.updatedAccountPopupStyle + " modal-overlay always-invisible"}></div>
            <div className="modal confirmation-modal" data-qa="update-profile-success-modal">
                <div className="row">
                    <p className="modal-text"><FormattedMessage id="YourPhoneNumberWasVerified"/></p>
                </div>
            </div>

            <div className={state.verificationCodePopupStyle + " modal-overlay always-invisible"}></div>
            <div className="modal confirmation-modal" data-qa="update-profile-success-modal">
                <div className="row">
                    <p className="modal-text"><FormattedMessage id="CodeSentToPhone"
                                                                values={{phoneNumber: phone}}/>
                    </p>
                </div>
            </div>



            <div className={state.closeVerificationPopupStyle + " modal-overlay "} onClick={() => setCloseVerificationModalStyle(hidden)}></div>
            <div className="modal" data-qa="close-verification-success-modal">
                <div className="row">
                    <p className="modal-text">By closing this verification process you will have to wait <strong>{getMinAndSecondsFromSeconds(state.resendTimer)}</strong> before starting over again.
                    </p>
                </div>

                <div className="row buttons-row">
                    <a className=" btn btn-link btn-md" onClick={() => setCloseVerificationModalStyle(hidden)} data-qa="delete-profile-cancel-delete"><FormattedMessage
                        id="Cancel"/></a>
                    <a className=" btn btn-link btn-danger no-underline no-border btn-md"
                       onClick={() => closeProcess()} data-qa="delete-profile-delete-btn"><FormattedMessage id="Close"/></a>
                </div>
            </div>



            <div className="login-container">
                <a className="btn-close" onClick={() => onCloseBtn()} data-qa="update-phone-number-close-btn"><img alt="close button"
                                                                                                                   src={closeIcon}/></a>

                {!countdown || state.resendTimer === 0?
                    <div className="login-container-content text-left">
                        <div className="login-container-content-top-text">
                            <h3><FormattedMessage id="EnterConfirmationCode"/></h3>
                        </div>

                        <div className="confirmation-code-input-container">

                            <div className="title row">
                                <br/>
                                <FormattedMessage id="WeJustSentConfirmationCode"
                                                  values={{phoneNumber: phone}}/>
                            </div>

                            <div className="row">
                                {state.confirmationCodeDefaultValue.map((digit, index) => (
                                    <input
                                        key={index}
                                        type="number"
                                        min="0"
                                        max="9"
                                        value={digit}
                                        onChange={(e) => handleCodeChangeAndVerification(e, index)}
                                        autoFocus={index === 0}
                                        ref={(input) => (inputRefs.current[index] = input)}
                                        readOnly={state.loading}
                                    />
                                ))}
                            </div>

                            {state.loading ?
                                <div className="spinner" data-qa="spinner"><Spinner/></div>
                                : null
                            }
                            {state.errorMsg != null ?
                                <>
                                    <div className="row">
                                        <div className="error-div" data-qa="update-profile-error-div">
                                            <p>&#9888;&nbsp;{state.errorMsg}</p>
                                        </div>
                                    </div>
                                </>
                                : null
                            }

                            <>
                                <div className="row tip">
                                    <p>
                                        <FormattedMessage
                                            id="WrongVerificationPhoneMessage"
                                            defaultMessage="WrongVerificationPhoneMessage"/>
                                    </p>
                                </div>
                                <div className="row">
                                    {state.resendTimer > 0 ? (
                                        <span className="disabled-timer">
                                          <FormattedMessage
                                              id="YouCanResendIn"
                                              defaultMessage="You can resend in {time}"
                                              values={{param: getMinAndSecondsFromSeconds(state.resendTimer)}}
                                          />


        </span>
                                    ) : (
                                        <a className="link underlined" onClick={resendCode}>
                                            <FormattedMessage id="ResendCode" defaultMessage="Resend Code"/>
                                        </a>
                                    )}
                                </div>
                            </>


                        </div>


                    </div>

                    :
                    <div className="login-container-content text-left">
                        <div className="login-container-content-top-text">
                            {state.resendTimer > 0 && <span className="disabled-timer">
                                          <FormattedMessage
                                              id="YouHaveToWaitBeforeChangingYourNumberAgain"
                                              defaultMessage="You have to wait {param} before changing your phone number again."
                                              values={{param: getMinAndSecondsFromSeconds(state.resendTimer)}}
                                          />


        </span>}
                        </div>
                    </div>

                }


            </div>
        </div>

    );
}

export default PhoneUpdateEnterPin;
